import { useCallback } from 'react'
import { isExpired } from 'react-jwt'
import { Navigate, Outlet } from 'react-router-dom'

import Cookies from 'js-cookie'

import { useNotification } from '../hooks/useNotification.js'

import CascaNova from '../novo/CascaNova'
import { guardarRetorno } from './retorno'
// import Denied from '@view/Denied/Denied'


const RequireAuth = (props: any) => {
  const { roles } = props
  const { notify } = useNotification()

  // verifica se o usuário esta autenticado
  const authenticated = useCallback(() => {
    const token = Cookies.get('TradeTalentosTokenPAT')
    if (token) {
      const isMyTokenExpired = isExpired(token)
      if (!isMyTokenExpired) {
        return true
      } else {
        notify('Sua sessão expirou', { variant: 'warning' })
        Cookies.remove('TradeTalentosTokenPAT')
        Cookies.remove('TradeTalentosUserPAT')
        return false
      }
    }
    return false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // verifica se o usuário tem acesso a pagina
  const autorized = useCallback(() => {
    const userObj: any = Cookies.get('TradeTalentosUserPAT')
    const myDecodedToken = JSON.parse(userObj)

    const userRoles = myDecodedToken?.role
      ? myDecodedToken.role.map((x: any) => x)
      : []

    let hasPermition = false

    // console.log('-----', userPortalRole, userRoles)
    // pagina não possui restrições de acesso
    if (!roles) return true

    // usuario não possui permissões de acesso configuradas
    if (!userRoles.length) return false

    // verfica se as permissoes do usuario batem com a restrição da pagina
    roles.forEach((pageRestrition: string) => {
      if (userRoles.includes(pageRestrition)) {
        hasPermition = true
      }
    })

    return hasPermition
  }, [roles]) // rest

  if (!authenticated()) {
    // Quem entrar volta para esta página (o link do book no e-mail, por exemplo).
    guardarRetorno(window.location.pathname + window.location.search)
    return (
      <Navigate
        to={{
          pathname: '/'
        }}
      />
    )
  }

  if (!autorized()) return <Navigate to="/nao-autorizado" />

  return (
    <CascaNova>
      <Outlet />
    </CascaNova>
  )
}

export default RequireAuth
